<template>
  <div>
    <!-- CONTENT -->
    <!--begin::Navbar-->
    <div class="card mb-5 mb-xl-10">
      <div class="card-body pt-0 pb-0">
        <!--begin::Navs-->
        <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'details'
              }"
              href="#"
              @click.prevent="changeTab('details')"
            >
              Detalhes
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'creatives'
              }"
              href="#"
              @click.prevent="changeTab('creatives')"
            >
              Criativos
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'pixels'
              }"
              href="#"
              @click.prevent="changeTab('pixels')"
            >
              Pixels
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'goals'
              }"
              href="#"
              @click.prevent="changeTab('goals')"
            >
              Metas
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'watchers'
              }"
              href="#"
              @click.prevent="changeTab('watchers')"
            >
              Watchers
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'wallets'
              }"
              href="#"
              @click.prevent="changeTab('wallets')"
            >
              Histórico de transações
            </a>
          </li>
          <!--end::Nav item-->
          <!--begin::Nav item-->
          <li class="nav-item mt-2" v-if="baseCampaign.status === 'PENDING'">
            <a
              class="nav-link text-active-primary ms-0 me-10 py-5"
              :class="{
                active: currentTab === 'finish-registration'
              }"
              href="#"
              @click.prevent="changeTab('finish-registration')"
            >
              Finalizar cadastro <i class="fas fa-warning ms-2" style="color: orangered !important;"></i>
            </a>
          </li>
          <!--end::Nav item-->
        </ul>
        <!--begin::Navs-->
      </div>
    </div>
    <!--end::Navbar-->
    <AlertWraper
      v-if="campaign.status === 'PENDING'"
      type="error"
      content="Campanha com status Pendente, finalize o cadastro na plataforma clicando na aba Finalizar Cadastro."
    />
    <!-- DETALHES TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'details'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Detalhes</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9">
        <template>
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">ID</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.id }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">ID sequencial</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.ref_id }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Nome</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.name }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Tipo</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.type | formatCampaignType }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Anunciante</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">
                <router-link
                  :to="{ name: 'advertisers.show', params: { id: campaign.advertiser.id }}"
                >
                  {{ campaign.advertiser.name }}
                </router-link>
              </span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Data de início</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.start_date | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Data de término</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.end_date | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Valor</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.amount/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Moeda</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.advertiser.currency | formatCurrencyType }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Taxa de câmbio</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.exchange_rate_amount / 100 | formatMoney }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Valor gasto</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.spending/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Valor disponível</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.available_amount/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7" v-if="campaign.type === 'NATIVE'">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Meta de CPM</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.cpm_target_amount / 100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Meta de CPC</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.cpc_target_amount / 100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Browsers</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign?.browser ? campaign.browser?.join(', ') : "N/A" }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Status</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.status | formatStatus }}</span>
              <template v-if="campaign.status === 'PENDING'" class="fw-semibold text-gray-800 fs-6">
                <Button class="ms-6 btn btn-sm btn-primary" @click="changeTab('finish-registration')"> Finalizar criação na Plataforma </Button>
              </template>
              <ul v-if="campaignAuditLogs?.length > 0">
                <li v-for="(log, index) in campaignAuditLogs" :key="index">Manualmente alterado: {{ log.user_name }} - {{ log.created_at }}</li>
              </ul>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Plataforma</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.platform }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7" v-if="campaign.platform === 'MANUAL'">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Planilha de resultados</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">
                <a :href="`https://docs.google.com/spreadsheets/d/${campaign.spreadsheet_id}/edit`" target="_blank">Clique aqui</a>
              </span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">ID na Plataforma</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.platform_id }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Impressões</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.impressions }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Cliques</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign?.clicks ? campaign?.clicks : 0 }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Conversões</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.conversions }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">CTR</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign?.ctr ? campaign?.ctr : 0 }}%</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">CPM</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.cpm/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">CPA</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.cpa/100 | formatMoney(campaign.advertiser.currency) }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Permitido apenas visualização para o usuário?</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.is_read_only ? 'Sim' : 'Não' }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Retenção</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign?.retention ? campaign?.retention : 0 }}%</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Data de criação</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.created_at | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!--begin::Input group-->
          <div class="row mb-7">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Data de última atualização</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6">{{ campaign.updated_at | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <!-- Retention -->
          <div class="mb-10" v-if="campaign.platform === 'GOOGLE' && !campaign.is_read_only && campaign.status !== 'FINISHED'">
            <UpdateRetentionForm
              :campaign="campaign"
              @update="reset()"
            />
          </div>
          <!-- end Retention -->
          <!--begin::Input group-->
          <div class="row mb-7" v-if="campaign.monday_id">
            <!--begin::Label-->
            <label class="col-lg-4 fw-semibold text-muted">Link para o Monday</label>
            <!--end::Label-->
            <!--begin::Col-->
            <div class="col-lg-8 fv-row">
              <span class="fw-semibold text-gray-800 fs-6"><a :href="'https://adsplay-midia.monday.com/boards/10023395495/pulses/' + campaign.monday_id" target="_blank" rel="noopener noreferrer">{{ 'https://adsplay-midia.monday.com/boards/10023395495/pulses/' + campaign.monday_id }}</a></span>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Input group-->
          <div class="text-center my-5" v-if="campaign.is_manual">
            <router-link class="btn btn-primary" :to="{ name: 'campaigns.edit', params: { id: campaign.id } }">Editar campanha</router-link>
          </div>
          <div class="d-flex flex-column flex-lg-row">
            <!-- IMPERSONATE -->
            <div class="col-12 col-lg-3 mb-7">
              <h3 class="m-0 text-gray-900 flex-grow-1">Impersonate</h3>
              <div class="mt-5">
                <ImpersonateButton
                  :userId="campaign.user_impersonate_id"
                />
              </div>
            </div> <!-- END IMPERSONATE -->
            <!-- SYNCHRONIZE CAMPAIGN -->
            <div class="col-12 col-lg-5 mb-7">
              <h3 class="m-0 text-gray-900 flex-grow-1">Sincronizar campanha com DV360</h3>
              <div class="mt-5">
                <SyncCampaignDv360Button
                  :campaign="baseCampaign"
                />
              </div>
            </div>
            <!-- END SYNCHRONIZE CAMPAIGN -->
            <!-- END CAMPAIGN -->
            <div class="col-12 col-lg-3 mb-7">
              <h3 class="m-0 text-gray-900 flex-grow-1">Encerrar Campanha</h3>
              <div class="mt-5">
                <EndCampaignButton
                  :campaign="baseCampaign"
                  @ended="handleEndedCampaign"
                  @error="handleEndCampaignError"
                />
              </div>
            </div>
            <!-- END END CAMPAIGN -->
          </div>
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END DETAILS TAB -->

    <!-- PIXELS TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'pixels'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Detalhes</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9">
        <template>
          <div class="table-responsive">
            <!--begin::Table-->
            <table class="table align-middle table-row-dashed fs-6 gy-5">
              <!--begin::Table head-->
              <thead>
                <!--begin::Table row-->
                <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                  <th class="min-w-100px">Nome do pixel</th>
                  <th class="min-w-70px">Nome da regra</th>
                  <th class="min-w-100px">Objetivo</th>
                  <th class="min-w-70px">Nome do evento</th>
                  <th class="min-w-70px">Status</th>
                </tr>
                <!--end::Table row-->
              </thead>
              <!--end::Table head-->
              <!--begin::Table body-->
              <tbody class="fw-semibold text-gray-600">
                <!--begin::Table row-->
                <tr v-for="(pixel, index) in campaign.pixels" :key="index">
                  <td>
                    <span>{{ pixel.pixel.name }}</span>
                  </td>
                  <td>
                    <span>{{ pixel.name }}</span>
                  </td>
                  <td>
                    <span>{{ pixel.objective }}</span>
                  </td>
                  <td>
                    <span>{{ pixel.event_name }}</span>
                  </td>
                  <td>
                    <span>{{ pixel.status | formatStatus }}</span>
                  </td>
                </tr>
                <!--end::Table row-->
              </tbody>
              <!--end::Table body-->
            </table>
          </div>
          <!--end::Table-->
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END PIXELS TAB -->

    <!-- CREATIVES TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'creatives'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Criativos</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9">
        <CreativeListTable
          :creatives="creatives"
        />
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END CREATIVES TAB -->

    <!-- GOALS TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'goals'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Metas</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9">
        <template>
          <div>
            <CampaignGoalListTable
              :campaignId="campaign.id"
              :reload="reloadGoalsAndWatchers"
            />
          </div>
          <div class="d-flex flex-column flex-sm-row mt-5 justify-content-center gap-3">
            <!-- Edit -->
            <Button
              class="btn btn-primary"
              v-b-modal="'upsert-campaign-goal'"
            >
              Criar meta
            </Button><!-- Edit -->
          </div>
          <UpsertCampaignGoalModal
            :campaignId="campaign.id"
            :currency="campaign.advertiser.currency"
            @upserted="handleUpsertedGoalAndWatchers"
          />
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END GOALS TAB -->

    <!-- WATCHERS TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'watchers'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Watchers</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9">
        <template>
          <div>
            <WatcherListTable
              :campaignId="campaign.id"
              :reload="reloadGoalsAndWatchers"
            />
          </div>
          <div class="d-flex flex-column flex-sm-row mt-3 justify-content-center gap-3">
            <!-- Edit -->
            <!-- <router-link
              :to="{ name: 'watchers.create', query: { campaign_id: campaign.id } }"
              class="btn btn-primary"
            >
              Criar watcher
            </router-link>Edit -->
          </div>
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END WATCHERS TAB -->

    <!-- WALLETS TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'wallets'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Histórico de transações</h3>
        </div>
        <!--end::Card title-->
        <!--begin::Action-->
        <!--end::Action-->
      </div>
      <!--begin::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9" v-if="campaign">
        <WalletListTable
          :campaignId="campaign.id"
        />
      </div>
      <!--end::Card body-->
    </div>
    <!--end::details View--> <!-- END WALLETS TAB -->
    <!-- END CONTENT -->

    <!-- FINISH REGISTRATION TAB -->
    <!--begin::details View-->
    <div class="card mb-5 mb-xl-10" v-show="currentTab === 'finish-registration'">
      <!--begin::Card header-->
      <div class="card-header cursor-pointer">
        <!--begin::Card title-->
        <div class="card-title m-0">
          <h3 class="fw-bold m-0"> Finalizar cadastro da campanha na plataforma</h3>
        </div>
        <!--end::Card title-->
      </div>
      <!--end::Card header-->
      <!--begin::Card body-->
      <div class="card-body p-9" v-if="campaign && campaign.status === 'PENDING'">
        <UpsertMgidCampaignForm
          :campaign="campaign"
          @upserted="reset(campaign.id)"
          v-if="campaign.type === 'PUSH' || campaign.type === 'NATIVE_CONTEXTUAL'"
        />
        <UpsertSpotifyCampaignForm
          :campaign="campaign"
          @upserted="reset(campaign.id)"
          v-if="campaign.type === 'AUDIO'"
        />
      </div>
      <!--end::Card body-->
    </div>
    <!-- END FINISH REGISTRATION TAB -->
    <!-- END CONTENT -->
  </div>
</template>

<script>

import LogsService from '@/modules/logs/services/logs-service'
import NotificationsService from '@/modules/notifications/services/notifications-service'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import CampaignGoalListTable from '@/components/campaign-goals/CampaignGoalListTable'
import CreativeListTable from '@/components/creatives/CreativeListTable'
import EndCampaignButton from '@/components/campaigns/EndCampaignButton'
import ImpersonateButton from '@/components/users/ImpersonateButton'
import UpdateRetentionForm from '@/components/campaigns/UpdateRetentionForm'
import SyncCampaignDv360Button from '@/components/campaigns/SyncCampaignDv360Button'
import UpsertCampaignGoalModal from '@/components/campaign-goals/UpsertCampaignGoalModal'
import UpsertMgidCampaignForm from '@/components/campaigns/Upsert/UpsertMgidCampaignForm'
import UpsertSpotifyCampaignForm from '@/components/campaigns/Upsert/UpsertSpotifyCampaignForm'
import WalletListTable from '@/components/wallets/WalletListTable'
import WatcherListTable from '@/components/watchers/WatcherListTable'

export default {
  props: ['baseCampaign', 'presetTab'],
  components: {
    AlertWraper,
    Button,
    CampaignGoalListTable,
    CreativeListTable,
    EndCampaignButton,
    ImpersonateButton,
    SyncCampaignDv360Button,
    WalletListTable,
    WatcherListTable,
    UpsertCampaignGoalModal,
    UpsertMgidCampaignForm,
    UpdateRetentionForm,
    UpsertSpotifyCampaignForm
  },
  data () {
    return {
      campaign: '',
      campaignAuditLogs: [],
      currentLineTab: 0,
      currentPackageTab: 0,
      currentTab: 'details',
      loader: false,
      reloadGoalsAndWatchers: false
    }
  },
  created () {
    this.campaign = this.baseCampaign

    //  If a tab is given, jump to pre-defined tab
    if (this.presetTab) this.currentTab = this.presetTab
    if (this.campaign.status === 'FINISHED') this.getCampaignAuditLogs()
  },
  computed: {
    /**
     * Creatives
     */
    creatives () {
      let array = []
      if (this.campaign.creatives?.creatives?.length > 0) array = [...array, ...this.campaign.creatives.creatives]
      if (this.campaign.creatives.square_creatives?.length > 0) array = [...array, ...this.campaign.creatives.square_creatives]
      if (this.campaign.type === 'AUDIO' && this.campaign.creatives.length > 0) array = [...array, ...this.campaign.creatives]
      return array
    },
    platformRedirectLink () {
      switch (this.campaign.platform) {
        case 'MGID':
          return 'https://ads.mgid.com/campaigns'
        case 'GOOGLE':
          return 'https://displayvideo.google.com/'
      }
      return ''
    },
    /**
     * Current tab title
     */
    tabTitle () {
      switch (this.currentTab) {
        case 'packages':
          return 'Grupos de Estratégias'
        default:
          return 'Detalhes'
      }
    }
  },
  methods: {
    /**
     * Change line tab
     */
    changeLineTab (tab) {
      this.currentLineTab = tab
    },
    /**
     * Change package tab and reset line tab
     */
    changePackageTab (tab) {
      this.currentPackageTab = tab
      this.currentLineTab = 0
    },
    /**
     * Change current tab
     */
    changeTab (tab) {
      this.currentTab = tab
    },
    /**
     * Get campaign audit logs
    */
    async getCampaignAuditLogs () {
      try {
        const logs = await LogsService.getActivityLogs({
          type: 'MANUALLY_END_CAMPAIGN',
          loggable_type: 'CAMPAIGN',
          loggable_id: this.baseCampaign.id
        })
        this.campaignAuditLogs = logs
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    /**
     * Handle error on campaign ending
    */
    handleEndCampaignError (error) {
      error.handleGlobally && error.handleGlobally()
    },
    /**
     * Handle ended campaign
     */
    handleEndedCampaign () {
      const notification = {
        notification: {
          type: 'success',
          content: 'Campanha encerrada com sucesso'
        }
      }
      NotificationsService.createGlobalSuccessNotification(notification)
      this.$emit('reload', this.baseCampaign)
    },
    /**
     * Handle upserted goal
    */
    handleUpsertedGoalAndWatchers (goal) {
      this.reloadGoalsAndWatchers = true
      setTimeout(() => {
        this.reloadGoalsAndWatchers = false
      }, 500)
    },
    /**
     * Reloads page
     */
    reset () {
      location.reload()
    }
  }
}
</script>
